import { render, staticRenderFns } from "./ClientLogoAttachments.vue?vue&type=template&id=978e9724&scoped=true"
import script from "./ClientLogoAttachments.vue?vue&type=script&lang=ts"
export * from "./ClientLogoAttachments.vue?vue&type=script&lang=ts"
import style0 from "./ClientLogoAttachments.vue?vue&type=style&index=0&id=978e9724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978e9724",
  null
  
)

export default component.exports